// extracted by mini-css-extract-plugin
export var sliderRange = "_ds-2";
export var sliderRoot = "_ds-0";
export var sliderThumb = "_ds-3";
export var sliderTrack = "_ds-1";